import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["for"];
const _hoisted_2 = {
    key: 0,
    class: "required"
};
const _hoisted_3 = ["id", "name", "rows", "placeholder"];
const _hoisted_4 = ["type", "id", "name", "placeholder"];
const _hoisted_5 = {
    key: 3,
    class: "valid-messages"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["field", { 'valid': _ctx.isValid && _ctx.inputValidated, 'invalid': !_ctx.isValid }])
    }, [
        (_ctx.labelText)
            ? (_openBlock(), _createElementBlock("label", {
                key: 0,
                for: _ctx.name
            }, [
                _createTextVNode(_toDisplayString(_ctx.labelText) + ": ", 1),
                (_ctx.required)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
                    : _createCommentVNode("", true)
            ], 8, _hoisted_1))
            : _createCommentVNode("", true),
        (_ctx.type === 'textarea')
            ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                key: 1,
                id: _ctx.name,
                name: _ctx.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.text) = $event)),
                rows: _ctx.rows,
                placeholder: _ctx.placeholderText(),
                onInput: _cache[1] || (_cache[1] =
                    //@ts-ignore
                    (...args) => (_ctx.checkInput && _ctx.checkInput(...args)))
            }, null, 40, _hoisted_3)), [
                [_vModelText, _ctx.text]
            ])
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 2,
                type: _ctx.type,
                id: _ctx.name,
                name: _ctx.name,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.text) = $event)),
                placeholder: _ctx.placeholderText(),
                onInput: _cache[3] || (_cache[3] =
                    //@ts-ignore
                    (...args) => (_ctx.checkInput && _ctx.checkInput(...args)))
            }, null, 40, _hoisted_4)), [
                [_vModelDynamic, _ctx.text]
            ]),
        (!_ctx.isValid)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errorsArr, (error, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: "error",
                        key: `error-${index + 1}`
                    }, [
                        _createElementVNode("span", null, _toDisplayString(error), 1)
                    ]));
                }), 128))
            ]))
            : _createCommentVNode("", true)
    ], 2));
}
